import { GridPaginationModel } from '@mui/x-data-grid-pro'

export const DATA_GRID_PAGE_SIZE = 50

export const DATA_GRID_PAGE_SIZE_OPTIONS = [10, 25, 50, 100, 200, 500, 1000]

export const DEFAULT_PAGINATION: GridPaginationModel = {
  page: 0,
  pageSize: DATA_GRID_PAGE_SIZE
}
